import { render, staticRenderFns } from "./c-dose-event-editor-dialog.vue?vue&type=template&id=0df16436&scoped=true&"
import script from "./c-dose-event-editor-dialog.vue?vue&type=script&lang=js&"
export * from "./c-dose-event-editor-dialog.vue?vue&type=script&lang=js&"
import style0 from "./c-dose-event-editor-dialog.vue?vue&type=style&index=0&id=0df16436&lang=scss&scoped=true&"
import style1 from "./c-dose-event-editor-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df16436",
  null
  
)

export default component.exports